import store from './index'

const getters = {
    /**
     * [getQuestionById description]
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    getQuestionById: state => id => {
        id = parseInt(id)
        let arr = state.questions.filter(question => question.id === id)
        let question = arr.shift()
        return question
    },

    availableAreas: state => {
        return [
            {
                name: 'Living Room',
                image: '/img/area-icons/master-bedroom.png'
            },
            {
                name: 'Master Bedroom',
                image: '/img/area-icons/master-bedroom.png'
            },
            {
                name: 'Bedroom',
                image: '/img/area-icons/master-bedroom.png'
            },
            {
                name: 'Kitchen',
                image: '/img/area-icons/master-bedroom.png'
            },
            {
                name: 'Laundry Room',
                image: '/img/area-icons/master-bedroom.png'
            },
            {
                name: 'Basement',
                image: '/img/area-icons/master-bedroom.png'
            }
        ]
    },

    selectedPlan: state => {
        let plans = state.system.monitoringPlans
        let interests = state.lead.automationInterests
        let automationEquipmentQtys = state.lead.automationQuantities

        if (plans.length > 0) {
            let plan = plans.filter(plan => plan.selected)[0]

            if (plan.type === 'pulse') {
                plan.features = [
                    'monitoring247',
                    'cellularConnection',
                    'twoWayCalling',
                    'smartphoneControl'
                ]

                if (
                    automationEquipmentQtys.FrontDoorCamera && interests.includes('Doorbell Camera') ||
                    automationEquipmentQtys.InteriorCameras && interests.includes('Interior Cameras')
                ) {
                    plan.features.push('videosAndCameras')
                }

                if (
                    automationEquipmentQtys.LightingControl && interests.includes('Lighting Control') ||
                    automationEquipmentQtys.RemoteDoorLocks && interests.includes('Remote Door Locks') ||
                    automationEquipmentQtys.SmartThermostat && interests.includes('Smart Thermostat')
                ) {
                    plan.features.push('homeControl')
                }
            }


            return plan
        }
    },

    pulsePlans(state) {
        let plans = state.system.monitoringPlans
        return plans.filter(plan => plan.type == 'pulse' && !plan.selected)
    },

    traditionalPlans(state) {
        let plans = state.system.monitoringPlans
        return plans.filter(plan => plan.type !== 'pulse' && !plan.selected)
    },

    equipmentByName: (state, getters) => name => {
        let equipment = state.equipment
        return equipment.filter(e => e.name == name)[0]
    },

    latLng(state) {
        let lat = 0
        let lng = 0
        if (state.lead.place && Object.keys(state.lead.place).length) {
            lat = state.lead.place.geometry.location.lat
            if (typeof state.lead.place.geometry.location.lat === 'function') {
                lat = state.lead.place.geometry.location.lat()
            }
            lng = state.lead.place.geometry.location.lng
            if (typeof state.lead.place.geometry.location.lng === 'function') {
                lng = state.lead.place.geometry.location.lng()
            }
        }

        return { lat, lng }
    },

    city(state) {
        if (state.lead.place && Object.keys(state.lead.place).length) {
            let obj = state.lead.place.address_components.filter(component => {
                return component.types.indexOf('locality') > -1
            })

            obj = obj[0]

            return obj.long_name
        }

        return ''
    },

    state(state) {
        if (state.lead.place && Object.keys(state.lead.place).length) {
            let obj = state.lead.place.address_components.filter(component => {
                return (
                    component.types.indexOf('administrative_area_level_1') > -1
                )
            })

            obj = obj[0]

            return obj.short_name
        }
        return ''
    },

    address(state) {
        if (state.lead.place && Object.keys(state.lead.place).length) {
            let streetNumberObj = state.lead.place.address_components.filter(
                component => {
                    return component.types.indexOf('street_number') > -1
                }
            )

            streetNumberObj = streetNumberObj[0]

            let streetNameObj = state.lead.place.address_components.filter(
                component => {
                    return component.types.indexOf('route') > -1
                }
            )

            streetNameObj = streetNameObj[0]

            return `${streetNumberObj.long_name} ${streetNameObj.short_name}`
        }

        return ''
    },

    zip(state) {
        if (state.lead.place && Object.keys(state.lead.place).length) {
            let obj = state.lead.place.address_components.filter(component => {
                return component.types.indexOf('postal_code') > -1
            })

            obj = obj[0]

            return obj.long_name
        }

        return ''
    }
}

export default getters
